import { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { ShieldCheck, ShieldX, WifiOff, Loader2 } from "lucide-react";
import { api } from "@/lib/api";
import { fmtDate } from "@/lib/format";
import { Logo, useSettings } from "@/components/common";

export function VerifyResult({ state }) {
  const view = !state ? { Icon: Loader2, cls: "text-slate-400 animate-spin", title: "Verifica in corso…" }
    : state.error ? { Icon: WifiOff, cls: "text-slate-500", title: "VERIFICA NON DISPONIBILE" }
    : state.valid ? { Icon: ShieldCheck, cls: "text-emerald-600", title: "LICENZA VALIDA" }
    : { Icon: ShieldX, cls: "text-red-600", title: "LICENZA NON VALIDA" };
  return (
    <div className="text-center">
      <view.Icon className={`mx-auto h-20 w-20 ${view.cls}`} />
      <div className="mt-4 font-display text-2xl font-black" data-testid="public-verify-result">{view.title}</div>
      {state?.message && <div className="mt-1 text-sm text-slate-600">{state.message}</div>}
      {state?.expiry_date && <div className="mt-2 text-sm font-semibold text-slate-800" data-testid="public-verify-expiry">Scadenza: {fmtDate(state.expiry_date)}</div>}
    </div>
  );
}

export function BrandMark() {
  const settings = useSettings();
  return (
    <Link to="/" className="mb-6 flex items-center justify-center gap-2" data-testid="public-brand-link">
      <Logo settings={settings} className="h-10 w-10" />
      <div className="text-left leading-tight"><div className="font-display font-bold text-[#0F2042]">Passrace</div><div className="text-[10px] font-semibold uppercase tracking-widest text-amber-600">Registro Nazionale MSP Italia</div></div>
    </Link>
  );
}

export const PRIVACY_NOTE = "Per tutela dei dati personali questa pagina pubblica non mostra informazioni sull'atleta. L'ammissione alle gare è verificata esclusivamente dagli organizzatori autorizzati tramite lo scanner dell'applicazione.";

export default function PublicVerify() {
  const { token } = useParams();
  const [state, setState] = useState(null);
  useEffect(() => {
    api.get(`/public/verify/${encodeURIComponent(token)}`).then((r) => setState(r.data)).catch(() => setState({ error: true }));
  }, [token]);

  return (
    <div className="flex min-h-screen items-center justify-center bg-[#F8FAFC] px-5">
      <div className="card-surface w-full max-w-md p-8 text-center fade-up" data-testid="public-verify-card">
        <BrandMark />
        <VerifyResult state={state} />
        <p className="mt-6 text-xs leading-relaxed text-slate-500">{PRIVACY_NOTE}</p>
        <div className="mt-6 flex flex-wrap justify-center gap-2">
          <Link to="/verifica" className="inline-block rounded-lg border border-slate-300 px-5 py-2.5 text-sm font-semibold text-[#0F2042] transition-colors hover:bg-slate-100" data-testid="public-verify-again-link">Verifica un'altra licenza</Link>
          <Link to="/login" className="inline-block rounded-lg bg-[#0F2042] px-5 py-2.5 text-sm font-semibold text-white transition-colors hover:bg-[#1E3A8A]" data-testid="public-verify-login-link">Accesso operatori</Link>
        </div>
      </div>
    </div>
  );
}
